// extracted by mini-css-extract-plugin
export default {"inCaseYouForgot":"IncaseYouForgot_inCaseYouForgot__CiyAm","wordsList":"IncaseYouForgot_wordsList__PB7pf"};